import {format, parse, parseISO} from 'date-fns';

function formatDate(d?: string | Date | null) {
  if (!d) return '';
  const dd = typeof d === 'string' ? parseDate(d) : d;
  if (!dd) return '';
  if (isNaN(dd.getTime())) {
    return '';
  }
  return format(dd, 'dd/MM/yyyy');
}

function parseDate(d: string): Date | null {
  try {
    // Try parseISO first for ISO format dates (e.g. 2023-01-01T00:00:00.000Z)
    const isoDate = parseISO(d);
    if (!isNaN(isoDate.getTime())) {
      return isoDate;
    }
    
    // Try other formats
    const formats = ['dd/MM/yyyy', 'yyyy-MM-dd', 'yyyy/MM/dd'];
    for (const fmt of formats) {
      const parsed = parse(d, fmt, new Date());
      if (!isNaN(parsed.getTime())) {
        return parsed;
      }
    }
    return null;
  } catch (error) {
    return null;
  }
}

const formatter = {
  formatDate,
  parseDate,
  formatTime: (d: string | Date) => {
    const dd = new Date(d);
    if (isNaN(dd.getTime())) {
      return '';
    }
    return format(dd, 'HH:mm:ss');
  },
  formatDateTime: (d: string | Date) => {
    const dd = new Date(d);
    if (isNaN(dd.getTime())) {
      return '';
    }
    return format(dd, 'yyyy-MM-dd HH:mm:ss');
  },

  formatFileSize: (size: number) => {
    if (size < 1024) {
      return `${size} B`;
    }
    size /= 1024;
    if (size < 1024) {
      return `${size.toFixed(2)} KB`;
    }
    size /= 1024;
    if (size < 1024) {
      return `${size.toFixed(2)} MB`;
    }
    size /= 1024;
    return `${size.toFixed(2)} GB`;
  },

  formatNumber: (n: number | string) => {
    if (typeof n === 'string') n = parseFloat(n);
    return n.toLocaleString('vi-VN');
  },

  formatDateSQL: (date?: Date | string) => {
    if (!date) return '';
    if (typeof date === 'string') date = new Date(date);
    return date ? format(date, 'yyyy-MM-dd') : '';
  },

  formatDateExcel(date?: Date) {
    if (!date) return '';
    if (typeof date === 'string') date = new Date(date);
    return (
      25569.0 + (date.getTime() - date.getTimezoneOffset() * 60 * 1000) / (1000 * 60 * 60 * 24)
    );
  },
};

export default formatter;
